<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<div class="flex flex-auto justify-center w-full sm:p-4 md:p-8 bg-gray-200 dark:bg-card">

    <!-- Navigation -->
    <ng-container *ngIf="isScreenSmall">
        <fuse-vertical-navigation
            class="dark bg-gray-900 print:hidden"
            [mode]="'over'"
            [name]="'mainNavigation'"
            [navigation]="navigation.default"
            [opened]="false">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationContentHeader>
                <!-- Logo -->
                <div class="flex items-center h-20 pt-6 px-8">
                    <img
                        class="w-30"
                        src="assets/images/logo/logo-text-on-dark.svg">
                </div>
            </ng-container>
        </fuse-vertical-navigation>
    </ng-container>

    <!-- Wrapper -->
    <div class="flex flex-col items-center flex-auto min-w-0 max-w-360 sm:rounded-xl shadow-2xl dark:shadow-none overflow-hidden">

        <!-- Header -->
        <div class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 bg-card border-b dark:bg-default print:hidden">
            <ng-container *ngIf="!isScreenSmall">
                <!-- Logo -->
                <div class="flex items-center mx-2 lg:mr-8">
                    <div class="hidden lg:flex">
                        <!-- Light version -->
                        <img
                            class="dark:hidden w-38"
                            src="assets/images/logo/logo-text.svg"
                            alt="Logo image">
                        <!-- Dark version -->
                        <img
                            class="hidden dark:flex w-24"
                            src="assets/images/logo/logo-text-on-dark.svg"
                            alt="Logo image">
                    </div>
                    <!-- Small version -->
                    <img
                        class="flex lg:hidden w-8"
                        src="assets/images/logo/logo.svg"
                        alt="Logo image">
                </div>
                <!-- Horizontal navigation -->
                <fuse-horizontal-navigation
                    class="mr-2"
                    [name]="'mainNavigation'"
                    [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
            </ng-container>
            <!-- Navigation toggle button - only show on mobile when not logged in -->
            <ng-container *ngIf="isScreenSmall && !isLoggedIn">
                <button
                    class="mr-2"
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                </button>
            </ng-container>
            <!-- Logo on mobile when logged in -->
            <ng-container *ngIf="isScreenSmall && isLoggedIn">
                <img
                    class="w-8 mr-2"
                    src="assets/images/logo/logo.svg"
                    alt="Logo image">
            </ng-container>
            <!-- Components -->
            <div class="flex items-center pl-2 ml-auto space-x-1 sm:space-x-2">
                <languages></languages>
                <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                <shortcuts></shortcuts>
                <notifications></notifications>
                <user></user>
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-col flex-auto w-full bg-default">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>

        <!-- Footer - hidden on mobile when logged in -->
        <div class="relative flex flex-0 items-center justify-start w-full h-16 sm:h-20 px-6 sm:px-8 z-49 bg-card border-t dark:bg-default print:hidden"
            [ngClass]="{'hidden': isScreenSmall && isLoggedIn, 'flex': !isScreenSmall || !isLoggedIn}">
            <span class="font-medium text-secondary">Trainerswap &copy; {{currentYear}}</span>
        </div>

        <!-- Mobile Bottom Navigation - only show when logged in -->
        <div *ngIf="isScreenSmall && isLoggedIn" 
            class="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-gray-200 dark:border-gray-700 safe-area-bottom print:hidden">
            <nav class="flex justify-around items-center h-16 max-w-360 mx-auto">
                <ng-container *ngFor="let item of navigation.default">
                    <a *ngIf="!item.hidden && item.link"
                        [routerLink]="item.link"
                        routerLinkActive="text-primary"
                        [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
                        class="flex flex-col items-center justify-center flex-1 h-full text-gray-500 hover:text-primary transition-colors"
                        #rla="routerLinkActive"
                        [class.text-primary]="rla.isActive">
                        <mat-icon [svgIcon]="item.icon" class="icon-size-6"></mat-icon>
                        <span class="text-xs mt-1 font-medium">{{ item.title | translate }}</span>
                    </a>
                </ng-container>
            </nav>
        </div>

        <!-- Spacer for mobile bottom nav -->
        <div *ngIf="isScreenSmall && isLoggedIn" class="h-16 flex-shrink-0"></div>

    </div>

</div>
